export enum AccessType {
    Self,
    AdminAccess,
    EmergencyAccess,
}
